import { GUTTER_SIZE } from "@/enums";
import { Col, Row } from "antd";
import { Gutter } from "antd/es/grid/row";
import { ReactNode } from "react";
import * as S from "./styled";

interface IProps {
  leftChildren?: ReactNode;
  rightChildren: ReactNode;
}

export const StickyActionsHeader = ({
  leftChildren,
  rightChildren,
}: IProps) => (
  <S.StickyActions className="viper-sticky-top">
    <Row
      className="m-0"
      gutter={GUTTER_SIZE.small as [Gutter, Gutter]}
      justify="end"
      align="middle"
    >
      <Col flex="50%" className="m-auto">
        {leftChildren}
      </Col>
      <Col flex="50%" className="m-auto">
        <Row
          className="m-0"
          gutter={GUTTER_SIZE.small as [Gutter, Gutter]}
          justify="end"
          align="middle"
        >
          {rightChildren}
        </Row>
      </Col>
    </Row>
  </S.StickyActions>
);
